import React from "react";
import { Button, Form, FormField, FormGroup, Modal } from "semantic-ui-react";

// Component
import TableIssueHistory from "./TableIssueHistory";

// Type
type ModalIssueHistoryProps = {
  // func
  onOpen: boolean;
  onClose: () => void;
  // data
  data: any[];
};

const ModalIssueHistory = (props: ModalIssueHistoryProps) => {
  return (
    <Modal open={props.onOpen} onClose={props.onClose} style={{ maxHeight: "70vh" }}>
      <Form style={{ margin: "1rem" }}>
        <FormGroup>
          <FormField>
            <label style={{ fontSize: "16px" }}>Work & Plan History</label>
          </FormField>
        </FormGroup>
        <FormGroup>
          <FormField width={16}>
            <TableIssueHistory
              data={props.data}
              style={{
                flex: "1 1 auto",
                overflow: "auto",
                height: "50vh",
              }}
            />
          </FormField>
        </FormGroup>
        <FormGroup>
          <FormField width={16} style={{ display: "flex", justifyContent: "center" }}>
            <Button children="CLOSE" color="red" onClick={props.onClose} />
          </FormField>
        </FormGroup>
      </Form>
    </Modal>
  );
};

export default ModalIssueHistory;
